import { ContentManagementProvider } from '../providers/contentManagementProvider';
import { AsyncAction } from '../../base-classes/asyncAction';

export const GET_CONTENT_TEMPLATE = new AsyncAction('GET_CONTENT_TEMPLATE');


export function getContentManagementTemplate(baseUrl, authId, secret, verbose, stdParams, resourceList)
{
    return {
        type: GET_CONTENT_TEMPLATE.base,
        payload: getContentTemplate(baseUrl, authId, secret, verbose, resourceList, stdParams)
    };
}


async function getContentTemplate(baseUrl, authId, secret, verbose, resourceList, stdParams) {
    const op = new ContentManagementProvider(baseUrl, authId, secret);
    return await op.getContentTemplate(verbose, stdParams, resourceList);
}
